import { Skeleton } from '@picsart/design-system/components/Skeleton';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import useStyles from './styles';

const PLACEHOLDER_KEYS = ['first', 'second', 'third'];

const TrendingCarouselSkeleton = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {PLACEHOLDER_KEYS.map((key) => (
        <Skeleton
          key={key}
          className={classes.slide}
          borderRadius={CornerRadius.r16}
        />
      ))}
    </div>
  );
};

export default TrendingCarouselSkeleton;
